import styled, { css } from 'styled-components/macro';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr;
  ${({ theme }) => css`
    grid-gap: ${theme.spacings.base};
  `}
`;

export const RequiredMark = styled.span`
  ${({ theme }) => css`
    margin-left: 2px;
    color: ${theme.colors.red[500]};
  `}
`;
